import styled from "styled-components"

import Button from "@irati/ui/src/Button"

interface Props {
  bgColor: string
}

export const StyledDiv = styled.div<Props>`
  background-color: ${({bgColor}) => bgColor};
  padding: ${({theme}) => theme.spacing.four};
`

export const StyledButton = styled(Button)`
  flex: 1 0 auto;
`
